import { chainOf, levelsOf } from "./packagesEditor";

export const url = "commerce/merchandise/products";
export const SUPPLIERS_URL = "assets/providers/filterByCategory";

const idOf = (value) => String(value?._id || value || "");

export const supplierLabel = ({ name, displayname } = {}) =>
  name || displayname || "Unknown supplier";

// tagged suppliers of a brand; older records only have the preferred `supplier`
export const supplierIdsOf = (product = {}) => {
  const ids = (product.suppliers || []).map(idOf).filter(Boolean);
  const preferred = idOf(product.supplier);
  return [...new Set(preferred ? [preferred, ...ids] : ids)];
};

export const preferredIdOf = (product = {}) => idOf(product.supplier);

// "1 box = 100 pcs", or "box › pack › stick (1 box = 1,440 stick)" for 3+ levels
export const packLabel = (variant, product) => {
  const levels = levelsOf(variant, product);
  if (!levels.length) return "";
  if (levels.length === 1) return levels[0].bu;
  const [top] = levels;
  const base = levels[levels.length - 1].bu;
  const size = `1 ${top.bu} = ${top.qnty.toLocaleString()} ${base}`;
  return levels.length > 2 ? `${chainOf(levels)} (${size})` : size;
};
// older records without variants are shown as one "Standard" variant
export const variantsOf = (product) =>
  product.variants?.length
    ? product.variants
    : [
        {
          name: "Standard",
          packaging: product.packaging,
          tests: product.tests,
          isDefault: true,
        },
      ];
